export interface DangerousGoods {
    unCode: {
        id: string,
        name: string
    },
    unCodeId: string;
    packing: string,
    packingId: string,
    packingQuantity: number,
    packingGroup: PackingType | string,
    weight: number
}

export interface DangerousGoodsInNewOrUpdateOrder {
    UNCode: string;
    packing: string;
    packingQuantity: number;
    packingGroup: PackingType | string;
    weight: number | null;
}

export enum PackingType {
    I = "I",
    II = "II",
    III = "III"
}